import type { FaireProductEntity } from "../../entity_types/product";

export const p_tpt5wb4n2m: FaireProductEntity = {
  token: "p_tpt5wb4n2m",
  type: "product",
  name: "14K Gold Filled 2mm Paperclip 20 Inch Minimalist Layering Chain Necklace | WA-2227",
  brandToken: "b_374b66mxaz",
  brandName: "Aim Eternal",
  imageUrl:
    "https://cdn.faire.com/fastly/b7547c03f26849281d427e5aa9f0c4908226e6d98c14cb0b63d50af998bac012.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53346be690ee949f9a40e9a2784ba2608807866b8a1d13bc88855d9d788158c1.jpeg",
    "https://cdn.faire.com/fastly/641d9a3661d1a39b67e797ddfe3ecff02620b9a148cf24aaad3dbaa80a08a468.jpeg",
  ],
  priceDollars: 7.61,
  description:
    "\nItem Details:\n\nGold Tone: 14K Gold Filled\n\nChain Style: Paperclip Chain \n\nLength: 19.6 Inches \n\nWidth: 2.1mm \n\nClosure: Spring Ring \n\n\n\nWant us to match the chains for a specific pendant from your order? Please leave a note at check out page so that we can take this request. Please follow this format on your message.\n\nChain Style desired: (preferably a link of one chain style as example from our website)\n\nPendants that you want us to match (SKU or the item link from our website):\n\nLength:\n\nWidth:\n\n\n\nHave some DIY ideas?\nhttps://dluxca.com/collections/bulk-roll-necklace-chain\n\nNeed some finished necklace chains to pair up?\nhttps://dluxca.com/collections/finished-chains\n\nCheck out our pendants here\nhttps://dluxca.",
  tags: [],
  msrpDollars: 15.21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:57.553Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
